import React from 'react';
import { TutorsListPage } from './presentation/TutorsListPage';
import { useTutorsList } from './useTutorsList';

export const TutorsListContainer = () => {
    const data = useTutorsList();
    return <TutorsListPage data={data} />;
}